import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../api/client";
import { useAuth } from "../contexts/AuthContext";

export default function Connexion() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [step, setStep] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [challengeToken, setChallengeToken] = useState("");
  const [emailMasked, setEmailMasked] = useState("");
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");
  const [busy, setBusy] = useState(false);

  const doLogin = async () => {
    setError(""); setInfo(""); setBusy(true);
    try {
      const r = await api.post("/auth/token", { email, password });
      if (r.challenge_required) {
        setChallengeToken(r.challenge_token);
        setEmailMasked(r.email_masked || "");
        setStep("challenge");
        setInfo(r.email_sent
          ? `Un code de vérification a été envoyé à ${r.email_masked}.`
          : "Un code de vérification est requis.");
      } else if (r.access_token) {
        await login(r.access_token);
        nav("/calendrier", { replace: true });
      }
    } catch (e) {
      setError(e.message || "Identifiants incorrects.");
    } finally { setBusy(false); }
  };

  const doVerify = async () => {
    setError(""); setBusy(true);
    try {
      const r = await api.post("/auth/verify-challenge", {
        challenge_token: challengeToken, code: code.trim(),
      });
      if (r.access_token) {
        await login(r.access_token);
        nav("/calendrier", { replace: true });
      }
    } catch (e) {
      setError(e.message || "Code incorrect.");
    } finally { setBusy(false); }
  };

  const doResend = async () => {
    setError(""); setInfo(""); setBusy(true);
    try {
      const r = await api.post("/auth/resend-challenge", { challenge_token: challengeToken });
      setChallengeToken(r.challenge_token);
      setInfo(`Un nouveau code a été envoyé à ${r.email_masked || emailMasked}.`);
    } catch (e) {
      setError(e.message || "Impossible de renvoyer le code.");
    } finally { setBusy(false); }
  };

  return (
    <div className="container" style={{ maxWidth: 460 }}>
      <h1>Connexion</h1>
      <p className="muted mb-3">Accédez aux événements qui vous sont réservés.</p>
      <div className="card">
        {error && <div className="error">{error}</div>}
        {info && <div className="success">{info}</div>}
        {step === "login" ? (
          <>
            <div className="field"><label>Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                     onKeyDown={(e) => e.key === "Enter" && doLogin()} /></div>
            <div className="field"><label>Mot de passe</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                     onKeyDown={(e) => e.key === "Enter" && doLogin()} /></div>
            <button onClick={doLogin} disabled={busy}>
              {busy ? "Connexion…" : "Se connecter"}
            </button>
            <p className="muted mt-2" style={{ textAlign: "center" }}>
              <Link to="/mot-de-passe-oublie">Mot de passe oublié ?</Link>
            </p>
            <p className="muted mt-2">
              Pas encore de compte ? <Link to="/inscription">Créer un compte</Link>
            </p>
          </>
        ) : (
          <>
            <div className="field"><label>Code de vérification</label>
              <input value={code} onChange={(e) => setCode(e.target.value)}
                     inputMode="numeric" autoFocus
                     onKeyDown={(e) => e.key === "Enter" && doVerify()} /></div>
            <button onClick={doVerify} disabled={busy}>
              {busy ? "Vérification…" : "Valider"}
            </button>
            <button className="secondary mt-2" style={{ width: "100%" }}
                    onClick={doResend} disabled={busy}>Renvoyer un code</button>
            <button className="secondary mt-2" style={{ width: "100%" }}
                    onClick={() => { setStep("login"); setCode(""); }}>← Retour</button>
          </>
        )}
      </div>
    </div>
  );
}
